import Store from 'conf-store';
import camelcase from 'camelcase-keys';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../tailwind.config';

const env = process.env.NODE_ENV || 'development';
const store = new Store({
  env,
  production: env === 'production',

  apollo: {
    http: {
      uri: process.env.GRAPHQL_URL || '/admin/api',
    },
  },

  // Expose TailwindCSS config values
  tw: camelcase(resolveConfig(tailwindConfig).theme, { deep: true }),

  cloudinary: {
    cloudName: process.env.CLOUDINARY_CLOUD_NAME || 'globobeet',
  },

  curator: {
    feedId: '5797a416-4826-4aaf-b13d-a3ff7bf11e22',
  },

  google: {
    analyticsTrackingId: 'UA-100821198-5',
  },

  sentry: {
    dsn: 'https://3d8c313e93eb4b08be93b9181b3ec7ad@o195131.ingest.sentry.io/5379091',
    environment: env,

    // Only send in production
    enabled: env === 'production',

    // Only send errors from our code
    whitelistUrls: ['flinchys.com/_next/static'],
  },
});

const config = (key, criteria = {}) => store.get(key, { env, ...criteria });
export default config;
